function getAccountTypeList(){
    return [
        {
            label: "银行公户",
            value: "public_bank",
        },
        {
            label: "微信公户",
            value: "public_wechat_pay",
        },
        {
            label: "支付宝公户",
            value: "public_ali_pay",
        },
        {
            label: "银行私户",
            value: "private_bank",
        },
        {
            label: "微信私户",
            value: "private_wechat_pay",
        },
        {
            label: "支付宝私户",
            value: "private_ali_pay",
        },
    ]
}

function getAccountType(key){
    const typeMap = {
        "public_bank": "银行公户",
        "public_wechat_pay": "微信公户",
        "public_ali_pay": "支付宝公户",
        "private_bank": "银行私户",
        "private_wechat_pay": "微信私户",
        "private_ali_pay": "支付宝私户",
    }
    return typeMap[key]?typeMap[key]:""
}
function getLabel(key){
    const labelMap = {
        'date':'按日',
        'week':'按周',
        'month':'按月',
        'time':'按时间段'}
    return labelMap[key]?labelMap[key]:""
}
function getRuleType(key){
    const typeMap = {
        'mean':[1,"取均值"],
        "min":[2,"取最小值"],
        "cust":[3,"自定义系数"],
        "new":[4,"新店自定义"],
        "mid":[5, "取中位数"],
        "":[0,"默认"]
    }
    return typeMap[key]?typeMap[key]:""
}
const roleTypeMap ={
    0: "商务",
    1:"投资评估",
    2:"商业评估"
  }
  const stageMap = {
    "1":'初筛',
    "2":"品牌评估",
    "3":"明细收集",
    "4":"投资方案",
    "5":"签署",
    "6":"投资",
    "7":"项目终止",
    "8":"投资结束",
    "9":"提前结束"

  }

  const yearOptions = function () {
    let startYear = 2023
    let currentYear = new Date().getFullYear();
    let yearsArray = [];
    for (let year = startYear; year <= currentYear; year++) {
      yearsArray.push({
          label: year + "年",
          value: year,
      });
    }
    yearsArray.reverse();
    return yearsArray
  }

export {
    getAccountType,
    getAccountTypeList,
    getRuleType,
    getLabel,
    roleTypeMap,
    stageMap,
    yearOptions

}